/** Danish (`da`) catalog. */
export const catalogDa: Record<string, string> = {
  "quiz.account.menu_aria_label": "Konto og log ud",
  "quiz.account.pending_summary": "Konto",
  "quiz.home.checking_session": "Tjekker om du er logget ind...",
  "quiz.home.cta_continue_my_quizzes": "Fortsæt til Mine quiz",
  "quiz.home.cta_create_quiz_primary": "Opret et quiz",
  "quiz.home.cta_sign_in_organizer": "Log ind",
  "quiz.home.footer_aux_aria_label": "Juridisk og hjælp",
  "quiz.home.footer_legal": "© {year} Quiz. Alle rettigheder forbeholdes.",
  "quiz.home.footer_link_contact": "Kontakt os",
  "quiz.home.footer_link_help": "Hjælpcenter",
  "quiz.home.footer_link_privacy": "Privatlivspolitik",
  "quiz.home.footer_link_terms": "Servicevilkår",
  "quiz.home.header_sign_in": "Log ind",
  "quiz.home.header_title": "Quiz",
  "quiz.home.hero_signed_in_generic": "Velkommen tilbage",
  "quiz.home.hero_signed_in_named": "Hej {name}",
  "quiz.home.hero_signed_in_subtitle":
    "Opret og administrer quiz til dine træningssessioner.",
  "quiz.home.hero_subtitle":
    "Inviter deltagere via e-mail. De læser materiale og gennemfører quizzen.",
  "quiz.home.hero_title": "Træningsquiz ud fra dine dokumenter",
  "quiz.home.label_display_name": "Vist navn",
  "quiz.home.label_user_id": "Bruger-ID",
  "quiz.home.link_my_quizzes": "Mine quiz",
  "quiz.home.link_view_existing_quizzes": "Gennemse eksisterende quiz",
  "quiz.home.link_new_training_quiz": "Start opsætningsguide (anbefalet)",
  "quiz.home.logout": "Log ud",
  "quiz.home.logout_failed": "Udlogning mislykkedes. Prøv igen.",
  "quiz.home.logout_pending": "Logger ud...",
  "quiz.home.participant_guidance_body":
    "Deltagerne får tilsendt et link til quizzen på e-mail.",
  "quiz.home.participant_guidance_summary": "Sådan deltager gæster",
  "quiz.home.role_organizers_bullet_1": "Upload træningsmateriale.",
  "quiz.home.role_organizers_bullet_2":
    "Generér spørgsmålpool og send invitationer.",
  "quiz.home.role_organizers_title": "Organisatorer",
  "quiz.home.role_participants_bullet_1": "Brug linket i mailen.",
  "quiz.home.role_participants_bullet_2": "Fuldfør quizzen.",
  "quiz.home.role_participants_title": "Deltagere",
  "quiz.home.session_error": "Kunne ikke læse login-status.",
  "quiz.home.signed_in_title": "Konto",
  "quiz.home.skip_to_main": "Spring til hovedindhold",
  "quiz.my_quizzes.title": "Mine quiz",
  "quiz.my_quizzes.loading": "Indlæser quiz...",
  "quiz.my_quizzes.empty":
    "Ingen kladder endnu. Opret et for at tilføje materiale. Navnet kan komme fra den første fil; ret det her inden udgivelse.",
  "quiz.my_quizzes.feature_off":
    "Træningsquiz er ikke aktiveret i denne installation.",
  "quiz.my_quizzes.sign_in_required": "Log ind for at administrere quiz.",
  "quiz.my_quizzes.load_failed": "Kunne ikke indlæse quiz.",
  "quiz.my_quizzes.create_submit": "Opret quiz",
  "quiz.my_quizzes.create_failed": "Kunne ikke oprette kladde. Prøv igen.",
  "quiz.my_quizzes.quiz_title_field": "Quiz-titel",
  "quiz.my_quizzes.save_title": "Gem titel",
  "quiz.my_quizzes.untitled_placeholder":
    "Uden titel — fra første fil eller indtast",
  "quiz.my_quizzes.title_save_failed": "Titlen kunne ikke gemmes. Prøv igen.",
  "quiz.my_quizzes.quiz_status_draft": "Kladde",
  "quiz.my_quizzes.quiz_status_published": "Publiceret",
  "quiz.my_quizzes.quiz_status_other": "{status}",
  "quiz.my_quizzes.summary_with_pipeline": "{lifecycle} · {pipeline}",
  "quiz.my_quizzes.generation_phase_running": "Genererer spørgsmål",
  "quiz.my_quizzes.generation_phase_failed": "Generering mislykkedes",
  "quiz.my_quizzes.generation_phase_queued": "Generering i kø",
  "quiz.my_quizzes.generation_phase_other": "{phase}",
  "quiz.my_quizzes.created_line": "Oprettet {date}",
  "quiz.my_quizzes.loading_more": "Indlæser flere…",
  "quiz.detail.back_my_quizzes": "Tilbage til Mine quiz",
  "quiz.detail.loading": "Indlæser quiz...",
  "quiz.detail.sign_in_required": "Log ind for at se denne quiz.",
  "quiz.detail.not_found": "Quiz ikke fundet eller ingen adgang.",
  "quiz.detail.load_failed": "Kunne ikke indlæse quizdata.",
  "quiz.detail.recipients_failed": "Kunne ikke indlæse modtagerlisten.",
  "quiz.detail.created_line": "Oprettet {date}",
  "quiz.detail.quiz_id_line": "Quiz-id: {quiz_id}",
  "quiz.detail.status_line": "Quiz-status: {status}",
  "quiz.detail.title_edit_aria": "Rediger quiz-titel",
  "quiz.detail.title_edit_glyph": "\u270E",
  "quiz.detail.title_confirm_aria": "Gem titel",
  "quiz.detail.title_confirm_glyph": "\u2713",
  "quiz.detail.title_cancel_aria": "Annuller",
  "quiz.detail.title_cancel_glyph": "\u2715",
  "quiz.detail.open_wizard_add_recipients":
    "Åbn guiden for at tilføje modtagere eller sende invitationer",
  "quiz.detail.pool_heading": "Spørgsmålpool",
  "quiz.detail.pool_summary":
    "Aktive: {active}. Gemt i alt: {total}. Inaktive (trækkes ikke): {inactive}.",
  "quiz.detail.pool_empty": "Ingen aktive spørgsmål i puljen.",
  "quiz.detail.roster_heading": "Testkandidater",
  "quiz.detail.roster_empty": "Ingen tildelinger endnu.",
  "quiz.detail.roster_empty_hint_wizard": "Åbn guiden for at invitere folk.",
  "quiz.detail.col_email": "E-mail",
  "quiz.detail.col_invitation": "Invitation",
  "quiz.detail.col_attempt": "Forsøg",
  "quiz.detail.col_completed": "Afsluttet",
  "quiz.detail.col_invite": "Invitationslink",
  "quiz.detail.completed_dash": "-",
  "quiz.detail.invitation_sent": "Sendt",
  "quiz.detail.invitation_not_sent": "Ikke sendt",
  "quiz.detail.attempt_pass": "Bestået",
  "quiz.detail.attempt_fail": "Ikke bestået",
  "quiz.detail.attempt_in_progress": "I gang",
  "quiz.detail.attempt_not_submitted": "Ikke startet",
  "quiz.detail.transcript_open_aria":
    "Åbn indsendt test-transkript for {email}",
  "quiz.detail.transcript_title": "Test-transkript",
  "quiz.detail.transcript_close": "Luk",
  "quiz.detail.transcript_fullscreen": "Fuld side",
  "quiz.detail.transcript_fullscreen_aria":
    "Åbn dette transkript på en fuld side",
  "quiz.detail.transcript_back_to_quiz": "Tilbage til testen",
  "quiz.detail.transcript_loading": "Indlæser transkript…",
  "quiz.detail.transcript_error": "Kunne ikke indlæse transkript.",
  "quiz.detail.transcript_meta_line": "{email} · {date}",
  "quiz.detail.transcript_attempt_id": "Forsøgs-ID: {id}",
  "quiz.detail.transcript_outcome_passed": "Resultat: Bestået",
  "quiz.detail.transcript_outcome_failed": "Resultat: Ikke bestået",
  "quiz.detail.transcript_score": "Score: {percent}%",
  "quiz.detail.transcript_selected_option": "Deres svar: {text}",
  "quiz.detail.transcript_correct_option": "Korrekt svar: {text}",
  "quiz.detail.transcript_no_selection": "(Intet svar registreret)",
  "quiz.detail.transcript_mark_correct": "Markeret korrekt",
  "quiz.detail.transcript_mark_incorrect": "Markeret forkert",
  "quiz.detail.transcript_signing_area_aria":
    "Underskriftsområde (plads til håndskrevne underskrifter ved udskrift)",
  "quiz.detail.get_invite_link": "Hent invitationslink",
  "quiz.detail.invite_link_confirm":
    "Opret et nyt invitationslink? Tidligere links til denne tildeling holder op med at virke.",
  "quiz.detail.invite_link_copied":
    "Invitationslink kopieret til udklipsholderen.",
  "quiz.detail.invite_link_manual_copy": "Kopier dette invitationslink:",
  "quiz.detail.invite_link_failed":
    "Kunne ikke hente invitationslinket. Prøv igen.",
  "quiz.detail.invite_link_no_origin":
    "Denne installation kan ikke bygge invitationslinks (mangler offentlig site-URL). Bed operatøren om at sætte QUIZ_INVITE_PUBLIC_ORIGIN.",
  "quiz.detail.choice_correct": "Korrekt: {text}",
  "quiz.wizard.page_title": "Træningsquiz-opsætning",
  "quiz.wizard.back_my_quizzes": "Mine quiz",
  "quiz.wizard.progress": "Trin {step} af {total}",
  "quiz.wizard.intro_lead": "Navn, kommende uploads, modtagere og forsendelse.",
  "quiz.wizard.create_draft_button": "Opret kladde og start",
  "quiz.wizard.create_failed": "Kunne ikke oprette kladde.",
  "quiz.wizard.loading_quiz": "Indlæser quiz...",
  "quiz.wizard.quiz_missing": "Kunne ikke indlæse quiz.",
  "quiz.wizard.need_sign_in": "Log ind igen fra forsiden.",
  "quiz.wizard.preview_note":
    "Generering og pool følger API'erne. SES via QUIZ_SES_MAIL_FROM. Materiale uploads kræver bucket (QUIZ_MATERIAL_BUCKET).",
  "quiz.wizard.step_title_name": "Navngiv quiz",
  "quiz.wizard.step_title_help": "Navn kan komme fra første fil; tilpas nu.",
  "quiz.wizard.save_title_continue": "Gem titel og videre",
  "quiz.wizard.step_training_heading": "Træningsmateriale",
  "quiz.wizard.step_training_body":
    "Upload op til tre .txt-filer (ren tekst, UTF-8), .pdf-filer eller .xlsx-filer. Vent til alle viser Klar, derefter Fortsæt. Skannede PDF-filer uden indlejret tekst giver lidt eller intet udtrukket tekst.",
  "quiz.wizard.step_generation_heading":
    "Genereringsindstillinger og spørgsmålspulje",
  "quiz.wizard.step_generation_body":
    "Angiv hvor mange spoergsmaal deltagere ser og svarets form, generer derefter udkast fra klar traeningsmateriale. Kurater puljen, indtil der er nok aktive spoergsmaal, og fortsaet.",
  "quiz.wizard.generation_pipeline_status": "Genereringspipeline: {status}",
  "quiz.wizard.generation_settings_heading": "Indstillinger for generering",
  "quiz.wizard.generation_settings_hint":
    "Standardvaerdier passer til de fleste quizzer.",
  "quiz.wizard.generation_questions_per_attempt_label": "Spoergsmaal pr. quiz",
  "quiz.wizard.generation_pool_count_label": "Spoergsmaalspuljens stoerrelse",
  "quiz.wizard.generation_pool_count_hint":
    "Standard er det dobbelte af antallet af spoergsmaal pr. quiz; hver bruger faar et tilfaeldigt udvalg.",
  "quiz.wizard.generation_shape_heading": "Spoergsmaalsform",
  "quiz.wizard.generation_option_count_label": "Svar pr. spoergsmaal",
  "quiz.wizard.generation_min_correct_label": "Minimum korrekte svar",
  "quiz.wizard.generation_max_correct_label": "Maksimum korrekte svar",
  "quiz.wizard.generation_shape_invalid":
    "Ret spoergsmaalsformen: der skal gaelde 1 <= minimum korrekte svar <= maksimum <= svar pr. spoergsmaal.",
  "quiz.wizard.generation_single_correct_note":
    "Automatisk generering giver stadig kun eet fuldstaendigt korrekt svar pr. spoergsmaal.",
  "quiz.wizard.generation_config_label":
    "Valgfrit JSON-objekt (flettes i quiz.configuration)",
  "quiz.wizard.generation_config_placeholder": "{}",
  "quiz.wizard.generation_queue_button": "Sæt generering i kø",
  "quiz.wizard.generation_busy": "Sender…",
  "quiz.wizard.generation_json_invalid": "Ugyldigt JSON-objekt.",
  "quiz.wizard.generation_failed": "Køen blev ikke oprettet.",
  "quiz.wizard.generation_material_not_ready":
    "Alle filer skal være Klar først.",
  "quiz.wizard.generation_locked": "Quiz låst efter udgivelse.",
  "quiz.wizard.generation_queued":
    "Generering i kø. Rediger puljen nedenfor, og fortsæt.",
  "quiz.wizard.generation_completed_failed":
    "Serveren markerede forsøget som mislykket.",
  "quiz.wizard.generation_done_reload":
    "Generering færdig - puljen er opdateret.",
  "quiz.wizard.generation_failed_banner":
    "Seneste generering slog fejl. Ret ekstrakter eller JSON (fx QUIZ_BEDROCK_MODEL_ID til Bedrock) og prøv igen.",
  "quiz.wizard.generation_running_notice":
    "Spørgsmål dannes ud fra READY-ekstrakter — vent kort.",
  "quiz.wizard.generation_reset_hint":
    "Efter Lambda-grænse plus en buffer (ofte få minutter) kan du nulstille, hvis den stadig viser running. Nulstil ikke, mens du tror generering kører aktivt.",
  "quiz.wizard.generation_reset_stuck_button": "Nulstil haengende generering",
  "quiz.wizard.generation_reset_busy": "Nulstiller…",
  "quiz.wizard.generation_reset_failed": "Kunne ikke nulstille.",
  "quiz.wizard.generation_reset_too_soon":
    "Generering kører måske stadig på serveren. Vent nogle minutter, prøv igen, eller genindlæs siden.",
  "quiz.wizard.pool_readonly_while_running":
    "Pool-redigering pauser mens generering kører.",
  "quiz.wizard.pool_edit": "Rediger",
  "quiz.wizard.pool_save_edit": "Gem ændring",
  "quiz.wizard.pool_cancel_edit": "Annuller",
  "quiz.wizard.generation_in_progress_blocked":
    "Generering kører allerede for denne quiz.",
  "quiz.wizard.generation_continue_blocked": "Sæt generering i kø først.",
  "quiz.wizard.generation_continue_blocked_pool":
    "For få aktive spørgsmål ift. questions_per_attempt; tilføj flere.",
  "quiz.wizard.pool_section_title": "Kladde-pulje",
  "quiz.wizard.pool_section_help":
    "Hvert spørgsmål kræver præcis {n, plural, one {# svarmulighed} other {# svarmuligheder}} (option_count i konfigurationen, standard fire).",
  "quiz.wizard.pool_empty":
    "Ingen kladde-spørgsmål endnu. Tilføj mindst et nedenfor.",
  "quiz.wizard.pool_stem_placeholder": "Spørgsmålstekst til deltagere",
  "quiz.wizard.pool_choice_label": "Valgmulighed {n}",
  "quiz.wizard.pool_correct_label":
    "Korrekt mulighed (1-baseret position i listen)",
  "quiz.wizard.pool_correct_multi_hint":
    "Mark every choice that should count as correct (within the minimum and maximum you set in generation settings).",
  "quiz.wizard.pool_choices_aria": "Svarmuligheder",
  "quiz.wizard.pool_correct_option_mark": "Korrekt",
  "quiz.wizard.pool_item_meta":
    "{count, plural, one {# mulighed} other {# muligheder}}; korrekt position {pos}",
  "quiz.wizard.pool_inactive_marker": "(inaktiv)",
  "quiz.wizard.pool_delete": "Fjern",
  "quiz.wizard.pool_add_aria": "Tilfoej spoergsmaal",
  "quiz.wizard.pool_add_button": "Tilføj spørgsmål",
  "quiz.wizard.pool_busy": "Gemmer pulje…",
  "quiz.wizard.pool_failed": "Puljeopdatering mislykkedes. Tjek felter.",
  "quiz.wizard.pool_validation": "Udfyld spørgsmål og alle muligheder.",
  "quiz.wizard.pool_publish_hint":
    "Aktive spørgsmål: {active}. Mindst {needed} aktive spørgsmål kræves.",
  "quiz.wizard.publish_pool_too_small":
    "Aktiv pulje mindre end questions_per_attempt. Gå tilbage til trin 3 og tilføj spørgsmål.",
  "quiz.wizard.step_invite_heading": "Modtagere",
  "quiz.wizard.step_invite_body": "En mail pr. linje; dedupe; maks 20.",
  "quiz.wizard.recipients_label": "E-mailadresser",
  "quiz.wizard.recipients_placeholder":
    "person1@organisation.dk\nperson2@organisation.dk",
  "quiz.wizard.recipients_hint": "Tom linje ignoreres; maks 20 adresser.",
  "quiz.wizard.publish_button": "Udgiv og send",
  "quiz.wizard.publish_failed": "Udgivelse mislykkedes; tjek emails.",
  "quiz.wizard.publish_conflict": "Quiz allerede udgivet.",
  "quiz.wizard.publish_validation": "Mindst en adresse ser forkert ud.",
  "quiz.wizard.back_step": "Tilbage",
  "quiz.wizard.continue": "Fortsæt",
  "quiz.wizard.success_title": "Invitationer gemt",
  "quiz.wizard.success_lead_publish":
    "Tildelinger gemt; mail via SES hvis konfigureret.",
  "quiz.wizard.success_lead_repeat":
    "Gemte invitationer: {count, plural, one {#} other {#}}.",
  "quiz.wizard.mail_notice_ses_optional":
    "SES aktiveres med QUIZ_SES_MAIL_FROM og verificerede identities.",
  "quiz.wizard.mail_notice_skipped":
    "SES er slået fra her; tilføj i produktion.",
  "quiz.wizard.mail_sent": "Sendt",
  "quiz.wizard.mail_failed": "Fejlede",
  "quiz.wizard.mail_skipped": "Sprunget over (ingen SES)",
  "quiz.wizard.col_email": "Modtager",
  "quiz.wizard.col_delivery": "Mailstatus",
  "quiz.wizard.back_to_my_quizzes": "Tilbage til Mine quiz",
  "quiz.wizard.view_quiz_detail": "Se quiz-detaljer",
  "quiz.wizard.material_docs_heading": "Uploadede filer",
  "quiz.wizard.material_empty": "Ingen fil endnu — tilføj mindst en.",
  "quiz.wizard.material_upload_pick": "Vælg fil (.txt, .pdf, .docx, .xlsx)",
  "quiz.wizard.material_choose_file": "Vælg fil",
  "quiz.wizard.material_drop_aria":
    "Tilføj træningsfiler ved at slippe dem her eller via filvælger",
  "quiz.wizard.material_drop_hint":
    "Slip filer her (.txt, .pdf, .docx, .xlsx) eller",
  "quiz.wizard.material_busy": "Uploader...",
  "quiz.wizard.material_no_file": "Vælg først en fil.",
  "quiz.wizard.material_failed": "Upload mislykkedes. Prøv igen.",
  "quiz.wizard.material_put_failed": "Direkte upload til lager fejlede.",
  "quiz.wizard.material_storage_off":
    "Materialelager ikke konfigureret (QUIZ_MATERIAL_BUCKET).",
  "quiz.wizard.material_limit": "Maksimalt antal filer nået.",
  "quiz.wizard.material_next_blocked": "Fortsæt kun når alle viser Klar.",
  "quiz.wizard.material_delete_aria": "Fjern fil",
  "quiz.wizard.material_remove_failed": "Filen kunne ikke fjernes. Prøv igen.",
  "quiz.wizard.material_state_AWAITING_BYTES": "Afventer upload",
  "quiz.wizard.material_state_INGESTING": "Behandler",
  "quiz.wizard.material_state_READY": "Klar",
  "quiz.wizard.material_state_FAILED": "Fejlet",
  "quiz.health.heading": "Backend-status",
  "quiz.health.loading": "Kalder GET /api/v1/health...",
  "quiz.health.httpStatus": "HTTP-status: {status}",
  "quiz.health.responseBody": "Svarindhold",
  "quiz.health.networkError": "API'en kunne ikke nås.",
  "quiz.health.notJson": "Svaret var ikke gyldig JSON.",
  "quiz.organizer.sign_in.title": "Log ind",
  "quiz.organizer.sign_in.lead": "Vælg en udbyder for at fortsætte.",
  "quiz.organizer.sign_in.google": "Fortsæt med Google",
  "quiz.organizer.sign_in.github": "Fortsæt med GitHub",
  "quiz.organizer.sign_in.bootstrap.heading": "Operatøroplysninger (miljø)",
  "quiz.organizer.sign_in.bootstrap.lead":
    "Til nødadgang, når OAuth ikke er tilgængelig.",
  "quiz.organizer.sign_in.bootstrap.username_label": "Brugernavn",
  "quiz.organizer.sign_in.bootstrap.password_label": "Adgangskode",
  "quiz.organizer.sign_in.bootstrap.submit": "Log ind",
  "quiz.organizer.sign_in.nav_home": "Hjem",
  "quiz.components.button.sample_label": "Fortsæt",
  "quiz.components.button.danger_sample": "Fjern",
  "quiz.components.icon_button.sample_aria": "Flere handlinger",
  "quiz.components.icon_button.sample_glyph": "+",
  "quiz.ui_demo.heading": "UI-komponentbibliotek",
  "quiz.ui_demo.lead":
    "Statisk oversigt over fælles quiz-frontend-kontroller på tværs af ruter.",
  "quiz.ui_demo.subheading_buttons": "Knapper",
  "quiz.ui_demo.caption_enabled": "Primær aktiv",
  "quiz.ui_demo.caption_disabled": "Primær deaktiveret",
  "quiz.ui_demo.caption_app_link": "Tekstlink",
  "quiz.ui_demo.caption_btn_danger": "Fareknap",
  "quiz.ui_demo.caption_btn_ghost": "Spøgelsesknap",
  "quiz.ui_demo.caption_btn_secondary": "Sekundær konturknap",
  "quiz.ui_demo.caption_icon_btn": "Ikonknap",
  "quiz.ui_demo.caption_layout_card": "Kortflade",
  "quiz.ui_demo.caption_layout_headings": "Overskriftsniveauer",
  "quiz.ui_demo.caption_layout_stack": "Lodret stak",
  "quiz.ui_demo.caption_layout_text": "Brødtekst og dæmpet tekst",
  "quiz.ui_demo.sample_app_link_label": "Åbn sundhedstjekside",
  "quiz.ui_demo.sample_card_body": "Eksempelindhold i kortet.",
  "quiz.ui_demo.sample_heading_h3": "Tredje overskriftsniveau",
  "quiz.ui_demo.sample_heading_h4": "Fjerde overskriftsniveau",
  "quiz.ui_demo.sample_text_body": "Primær brødtekst til beskrivelser.",
  "quiz.ui_demo.sample_text_muted": "Dempet hjælpetekst.",
  "quiz.ui_demo.skip_to_main": "Spring til hovedindhold",
  "quiz.ui_demo.stack_line_one": "Stak række et",
  "quiz.ui_demo.stack_line_two": "Stak række to",
  "quiz.ui_demo.subheading_forms": "Formularer",
  "quiz.ui_demo.subheading_layout": "Layout og typografi",
  "quiz.ui_demo.caption_field_file": "Fil med etiket",
  "quiz.ui_demo.caption_field_radio": "Radiogruppe",
  "quiz.ui_demo.caption_field_select": "Rulleliste",
  "quiz.ui_demo.caption_field_text": "Tekst med hjælp",
  "quiz.ui_demo.caption_field_text_invalid": "Tekst med fejl",
  "quiz.ui_demo.caption_field_textarea": "Tekstområde",
  "quiz.ui_demo.caption_checkbox": "Afkrydsningsfelt",
  "quiz.ui_demo.forms_error_required": "Navn er påkrævet.",
  "quiz.ui_demo.forms_file_hint": "Accepterer kun .txt i demo.",
  "quiz.ui_demo.forms_hint_name": "Vises som vist navn i formularer.",
  "quiz.ui_demo.forms_label_agree": "Jeg accepterer demo-betingelserne",
  "quiz.ui_demo.forms_label_bio": "Biografi",
  "quiz.ui_demo.forms_label_locale": "Forhåndsvisning sprog",
  "quiz.ui_demo.forms_label_name": "Vist navn",
  "quiz.ui_demo.forms_label_upload": "Træningsfil",
  "quiz.ui_demo.forms_placeholder_bio": "Kort biografitekst",
  "quiz.ui_demo.forms_placeholder_name": "Ada Lovelace",
  "quiz.ui_demo.forms_radio_a": "Valgmulighed A",
  "quiz.ui_demo.forms_radio_b": "Valgmulighed B",
  "quiz.ui_demo.forms_radio_legend": "Vælg en mulighed",
  "quiz.ui_demo.forms_select_de": "Tysk",
  "quiz.ui_demo.forms_select_en": "Engelsk",
  "quiz.ui_demo.alert_error_body": "Ret felter markeret med fejl.",
  "quiz.ui_demo.alert_error_title": "Gemning mislykkedes",
  "quiz.ui_demo.alert_info_body": "Baggrundsjobs kan tage et minut.",
  "quiz.ui_demo.alert_info_title": "OBS",
  "quiz.ui_demo.alert_success_body": "Kladde blev gemt.",
  "quiz.ui_demo.alert_success_title": "Gemt",
  "quiz.ui_demo.alert_warn_body": "Poolstørrelse er tæt på minimum.",
  "quiz.ui_demo.alert_warn_title": "Tjek pool",
  "quiz.ui_demo.caption_alert_error": "Fejlalert",
  "quiz.ui_demo.caption_alert_info": "Infoalert",
  "quiz.ui_demo.caption_alert_success": "Succesalert",
  "quiz.ui_demo.caption_alert_warning": "Advarselsalert",
  "quiz.ui_demo.caption_badges": "Statusmærker",
  "quiz.ui_demo.caption_empty_demo": "Tom tilstand",
  "quiz.ui_demo.caption_loading_row": "Indlæsningslinje",
  "quiz.ui_demo.caption_progress_demo": "Fremskridt",
  "quiz.ui_demo.caption_table_demo": "Simpel tabel",
  "quiz.ui_demo.display_badge_neutral": "Kladde",
  "quiz.ui_demo.display_badge_success": "Klar",
  "quiz.ui_demo.display_badge_warning": "Ko",
  "quiz.ui_demo.display_empty_body": "Opret et quiz for at se listen.",
  "quiz.ui_demo.display_empty_title": "Ingen quizzer",
  "quiz.ui_demo.display_progress_text": "Trin 2 af 5 (demo).",
  "quiz.ui_demo.display_table_col_email": "E-mail",
  "quiz.ui_demo.display_table_col_state": "Tilstand",
  "quiz.ui_demo.display_table_row1_email": "a@example.com",
  "quiz.ui_demo.display_table_row1_state": "SENT",
  "quiz.ui_demo.display_table_row2_email": "b@example.com",
  "quiz.ui_demo.display_table_row2_state": "NOT_SENT",
  "quiz.ui_demo.loading_label": "Indlæser quizzer...",
  "quiz.ui_demo.subheading_display": "Datavisning",
  "quiz.ui_demo.subheading_feedback": "Advarsler og indlæsning",
  "quiz.ui_demo.locale_picker_label": "Grænsefladesprog",
  "quiz.ui_demo.caption_disclosure": "Sammenklappelig blok",
  "quiz.ui_demo.caption_mc_option": "Multiple choice felter",
  "quiz.ui_demo.caption_modal": "Modal dialog",
  "quiz.ui_demo.caption_pool_row": "Pool række",
  "quiz.ui_demo.caption_reader": "Træningslæser",
  "quiz.ui_demo.domain_mc_opt_a": "Valgmulighed A tekst",
  "quiz.ui_demo.domain_mc_opt_b": "Valgmulighed B tekst",
  "quiz.ui_demo.domain_pool_meta": "4 valg · aktiv",
  "quiz.ui_demo.domain_pool_stem": "Hvad er første skridt i tjeklisten?",
  "quiz.ui_demo.domain_reader_sample":
    "Uddrag: verificer identitet før adgang.",
  "quiz.ui_demo.overlay_disclosure_body": "Ekstra politik kan skjules.",
  "quiz.ui_demo.overlay_disclosure_summary": "Vis politik",
  "quiz.ui_demo.overlay_modal_body": "Nativ dialog til bekræftelser.",
  "quiz.ui_demo.overlay_modal_close": "Luk",
  "quiz.ui_demo.overlay_modal_open": "Åbn demo-dialog",
  "quiz.ui_demo.overlay_modal_title": "Demo-dialog",
  "quiz.ui_demo.subheading_domain": "Quiz widgets",
  "quiz.ui_demo.subheading_overlays": "Overlays",
  "quiz.participant.answer_all": "Besvar alle spørgsmål før indsendelse.",
  "quiz.participant.error_load":
    "Invitationen kan være ugyldig eller udløbet. Brug linket i den seneste e-mail eller kontakt arrangøren.",
  "quiz.participant.error_missing_token":
    "Denne side kræver et komplet invitationslink med token.",
  "quiz.participant.error_title": "Dette link kunne ikke åbnes",
  "quiz.participant.loading": "Indlæser din opgave…",
  "quiz.participant.name_back_material": "Tilbage til uddannelsesmateriale",
  "quiz.participant.name_continue": "Fortsæt",
  "quiz.participant.name_heading": "Dine oplysninger",
  "quiz.participant.name_hint":
    "Vises i resultatoversigten når arrangøren har tilrettelagt et navneskilt.",
  "quiz.participant.name_intro":
    "Angiv det navn arrangøren skal se på denne quiz.",
  "quiz.participant.name_label": "Dit navn",
  "quiz.participant.name_placeholder": "fx Jordan Smith",
  "quiz.participant.name_required": "Angiv dit navn for at fortsætte.",
  "quiz.participant.nav_back": "Tilbage",
  "quiz.participant.nav_next": "Næste",
  "quiz.participant.abort_attempt": "Afbrud forsøg",
  "quiz.participant.abort_attempt_confirm":
    "Vil du stoppe dette forsøg? Dine svar kasseres. Hvis du allerede har gennemført et forsøg, vises det resultat i stedet.",
  "quiz.participant.abort_attempt_aria":
    "Afslut quizforsøget uden at indsende dine svar",
  "quiz.participant.progress_label": "Spørgsmål {current} af {total}",
  "quiz.participant.question_heading": "Spørgsmål",
  "quiz.participant.resume_attempt": "Fortsæt quiz",
  "quiz.participant.result_failed": "Ikke bestået",
  "quiz.participant.result_passed": "Bestået",
  "quiz.participant.result_ident_quiz_label": "Quiz",
  "quiz.participant.result_ident_participant_label": "Gennemført af",
  "quiz.participant.result_ident_participant_not_set": "Navn ikke angivet",
  "quiz.participant.result_training_heading":
    "Undervisningsmateriale i denne quiz",
  "quiz.participant.result_transcript_heading": "Dine svar",
  "quiz.participant.transcript_option_aria": "Dit svar {n}: {text}",
  "quiz.participant.transcript_question_correct": "Korrekt",
  "quiz.participant.transcript_question_wrong": "Forkert",
  "quiz.participant.result_transcript_selection_note":
    "Resultater pr. sp\u00f8rgsm\u00e5l er ikke tilg\u00e6ngelige i denne visning. Nedenfor ser du kun de valgmuligheder, du valgte.",
  "quiz.participant.result_retry": "Pr\xf8v igen",
  "quiz.participant.score_label": "Score: {percent}%",
  "quiz.participant.score_label_with_threshold":
    "Score: {percent}% \u2014 best\u00e5elseskrav {passPercent}%",
  "quiz.participant.skip_to_main": "Spring til hovedindhold",
  "quiz.participant.start_attempt": "Start quiz",
  "quiz.participant.submit_assignment_issued": "Invitation sendt {datetime}",
  "quiz.participant.submit_answers": "Indsend svar",
  "quiz.participant.submitting": "Indsender…",
  "quiz.participant.training_intro":
    "\u00c5bn hvert fil-link for at gemme en kopi af dokumentet f\xf8r du starter.",
  "quiz.participant.training_resume_intro":
    "Du er allerede begyndt på denne quiz. Gennemse uddannelsesmaterialet om n\xf8dvendigt, og forts\xe6t derefter hvor du slap.",
  "quiz.participant.training_docs_empty":
    "Der er endnu ikke nogen dokumenter tilknyttet denne quiz.",
  "quiz.participant.training_doc_download_aria":
    "Download dokumentet {filename}",
  "quiz.participant.training_heading": "Uddannelsesmateriale",
};
